import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';

/**
 * Remittance-lock notice (DESIGN State A §1) — white card, 3px black left
 * border, padlock icon. Shown at the top of the activated Advance COD tab.
 */
function AdvanceLockBanner() {
  const { t } = useTranslation();
  return (
    <div
      className='mb-3.5 flex items-start gap-3 rounded-xl border border-solid border-[#EBEBE6] bg-white px-[18px] py-3.5'
      style={{ borderLeft: '3px solid #151512' }}
      data-testid='advance-cod-lock-banner'
    >
      <Lock className='mt-px h-[18px] w-[18px] shrink-0 text-[#151512]' strokeWidth={1.9} />
      <p className='m-0 text-[13.5px] leading-[1.5] text-[#4A4A44]'>
        <b className='text-[#1B1B18]'>{String(t('advance_cod_lock_banner_title'))}</b>{' '}
        {String(t('advance_cod_lock_banner_body'))}
      </p>
    </div>
  );
}

export default AdvanceLockBanner;
